import React from "react";
import { batch, useDispatch } from "react-redux";
import { MdClose } from "react-icons/md";
import { DefaultText } from "theme/GlobalElements";
import styled from "styled-components/macro";
import Modal from "react-modal";
import { updateCartData } from "features/cart/cartSlice";
import Button from "components/Button";
import { buttonType } from "components/Button/Button";
import { MdDone } from "react-icons/md";
import { zIndexes } from "theme/Theme";
import { useNavigate } from "react-router-dom";
import { hideRootModal } from "../rootModalSlice";

const CheckoutSuccessModal = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const closeStatsModal = () => {
    batch(() => {
      dispatch(updateCartData([]));
      dispatch(hideRootModal());
    });
    navigate("/");
  };

  Modal.setAppElement("#root"); //fixing console error
  return (
    <Modal
      isOpen={true}
      onRequestClose={closeStatsModal}
      style={customStyles}
      contentLabel="Example Modal"
    >
      <Header>
        <MdClose size="1.5em" className="delete" onClick={closeStatsModal} />
      </Header>
      <Body>
        <Text fontSize={14} color="black">
          Поръчката Ви е приета,
          <br /> моля проверете имейла си.
        </Text>
        <ButtonsContainer>
          <Button
            onClick={closeStatsModal}
            title="ОК"
            type={buttonType.blueBtn}
          >
            <MdDone
              style={{
                width: 24,
                height: 24,
                color: "white",
                marginRight: "5px",
              }}
            />
          </Button>
        </ButtonsContainer>
      </Body>
    </Modal>
  );
};
const Header = styled.div`
  display: inline-flex;

  width: 100%;
  justify-content: flex-end;
`;
const Body = styled.div``;
const ButtonsContainer = styled.div`
  display: inline-flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  padding: 2.5px 0;
  margin-top: 10px;
`;
const Text = styled(DefaultText)`
  text-align: center;
  padding: 0 10px;
`;

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    padding: "10px",
  },

  overlay: {
    backgroundColor: "rgb(0 0 0 / 67%)",
    zIndex: zIndexes.backdrop,
  },
};
export default CheckoutSuccessModal;
